export default "__VITE_ASSET__BTauslyh__"